import React from 'react';
import classnames from 'classnames';

import { InnerBlocks } from '../assets/components';
import { selectOutlineFlow } from './util';

export function BaseSection({ data, ...rest }) {
  const { attributes, innerBlocks } = data;

  const {
    className,
    tagName: Tag,
    blockClass,
    prefix,
    hasSidebar,
    sidebarAlignmentRight,
    hasEqualColumns,
    hasSingleColumn,
    outlineFlowAuto,
    outlineFlow,
    fullWidth,
    contentAlign,
    noSpacingTop,
    noSpacingBottom,
    anchor,
  } = attributes;

  const blockClasses = classnames(blockClass, className, {
    'has-sidebar': hasSidebar,
    'has-sidebar-right': hasSidebar && sidebarAlignmentRight,
    'has-sidebar-left': hasSidebar && !sidebarAlignmentRight,
    [`has-single-column-align-${contentAlign}`]: hasSingleColumn && !fullWidth,
    'has-single-column-full-width': hasSingleColumn && fullWidth,
    'has-equal-columns': hasEqualColumns,
    'has-outline-flow-auto': outlineFlowAuto,
    [`has-outline-flow-${outlineFlow}`]: !outlineFlowAuto,
    'has-no-spacing-top': noSpacingTop,
    'has-no-spacing-bottom': noSpacingBottom,
  });

  const innerBlocksClasses = classnames(`${prefix}__inner-blocks`, {});

  return (
    <>
      <Tag
        id={anchor}
        className={blockClasses}
        outline-flow={outlineFlowAuto ? selectOutlineFlow(attributes) : `${outlineFlow}`}
      >
        <InnerBlocks className={innerBlocksClasses} blocks={innerBlocks} />
      </Tag>
    </>
  );
}
